import { format } from 'date-fns'
import { useState } from 'react'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { AppTable } from 'components/AppTable'

import { HistoryStatusObject } from 'models/status'

interface StatusHistoryProps {
  list?: Array<HistoryStatusObject>
}

export const StatusHistory = ({ list }: StatusHistoryProps) => {
  const [open, setOpen] = useState(false)

  const openModal = () => {
    setOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const closeModal = () => {
    setOpen(false)
    document.body.style.overflow = 'auto'
  }

  if (list && list.length > 0) {
    return (
      <>
        <AppButton variant="gray" onClick={openModal}>
          История статусов
        </AppButton>

        {open && (
          <AppModal onClose={closeModal} title="История статусов">
            <AppTable
              headers={[
                {
                  data: 'Дата',
                  key: 'created_at',
                  render: (_, data) => {
                    return format(new Date(data.created_at), 'yyyy-MM-dd HH:mm')
                  },
                  width: 20,
                },
                {
                  data: 'Пользователь',
                  key: 'user',
                },
                {
                  data: 'Статус', 
                  key: 'status',
                },
              ]}
              dataSource={list}
            />
          </AppModal>
        )}
      </>
    )
  }
  return null
}
